@if (data()?.rowData?.length) {
<ngx-datatable class='material' [rows]="data().rowData" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="0"
  [rowHeight]="'auto'" [rowClass]="getRowClass" (activate)="data().rowClickEvent($event)">
  @for (column of data().columnMappings; track column) {
  <ngx-datatable-column [name]="column.name" [prop]="column.prop">
    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
      @if (column.name !=='Paid') {
      <div class="cell-content">
        {{ getValueByPath(row, column.prop) }}
      </div>
      }
      @if (column.name ==='Paid') {
      <div class="cell-content">
        {{ getValueByPath(row, column.prop) ? 'No' : 'Yes' }}
      </div>
      }
    </ng-template>
  </ngx-datatable-column>
  }
  @for (action of data().actions; track action) {
  <ngx-datatable-column name="Action" [sortable]="false">
    <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
      <div class="cell-content action-cell" (click)="preventDefaultRowClickBehavior($event)">
        @if (action.visibilityHandler ? action.visibilityHandler(row) : data().isSearchResult === false) {
        <button mat-icon-button class="action-button" type="button"
          [disabled]="action.enableStateHandler && !action.enableStateHandler(row)"
          (click)="action.handler(row, $event)">
          <mat-icon matTooltip="{{ action.tooltip }}" id="0" matTooltipShowDelay="1000">
            {{ action.icon }}
          </mat-icon>
        </button>
        }
        @if (data().isSearchResult === true) {
        <div class="horizontal">
          @if (row.metadataInformation?.printButtons == null) {
          <button mat-icon-button class="action-button" type="button" (click)="action.handler(row, $event)">
            <mat-icon matTooltip="{{ action.tooltip }}" id="0" matTooltipShowDelay="1000">
              {{ action.icon }}
            </mat-icon>
          </button>
          }
          @for (printButton of row.metadataInformation?.printButtons; track printButton; let i = $index) {
          <button mat-icon-button class="action-button" type="button"
            [disabled]="action.enableStateHandler && !action.enableStateHandler(row)"
            (click)="action.handler(row, $event)" [style.color]="printButton?.backgroundColor">
            <mat-icon matTooltip="{{ action.tooltip }}" id="{{i}}" matTooltipShowDelay="1000">
              {{ action.icon }}
            </mat-icon>
          </button>
          }
        </div>
        }
      </div>
    </ng-template>
  </ngx-datatable-column>
  }
</ngx-datatable>
}